export default "__VITE_PUBLIC_ASSET__ee6a2ce5__"